module.exports = __webpack_public_path__ + "static/media/dummyTasks.56bb8b44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/website/features/tasksFeature/dummyTasks.jpg
// module id = 990
// module chunks = 0